LOCAL_PREFERENCES_EMAIL_SIGNUP_ADDRESS